import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { AdminPageTabList, BusinessExperienceForm } from "../components";
import { BusinessExperienceList } from "../components/businessExperienceList";
import { EventSeriesList } from "../components/event-series/components/event-series-list";
import { BusinessInstance } from "../utils/businessClass";
import { Dashboard } from "./DashboardPage";

const tabs = [
  {
    title: "Create Experience",
  },
  {
    title: "Past Experiences",
  },
  {
    title: "Upcoming Experiences",
  },
  {
    title: "Event Series",
  },
];

export const ExperiencesPage = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const { activeBusiness, businessType } = useSelector((state: any) => state.business);
  const [activeTab, setActiveTab] = useState(tabs[0]);
  const { isLoading, experiences, experience } = useSelector((state: any) => state.experience);
  const [editingExp, setEditingExp] = useState(experience);

  const handleFetchExperiences = async () => {
    await BusinessInstance.getBusinessExperiences(activeBusiness.id, businessType);
  };
  useEffect(() => {
    //get our experiences
    handleFetchExperiences();
  }, []);

  const handleEditExperience = (exp: any) => {
    setEditingExp(exp);
    setActiveTab({ title: "editing" });
  };

  const handleDuplicateExperience = (exp: any) => {
    setEditingExp(exp);
    setActiveTab({ title: "Create Experience" });
  };

  const renderActiveTabContent = () => {
    switch (activeTab.title) {
      case "Create Experience":
        return <BusinessExperienceForm experience={editingExp} isNew={true} />;
      case "Past Experiences":
        return (
          <BusinessExperienceList
            isPast={true}
            actions={{
              get: handleFetchExperiences,
              edit: handleEditExperience,
              duplicate: handleDuplicateExperience,
            }}
          />
        );
      case "Upcoming Experiences":
        return (
          <BusinessExperienceList
            isPast={false}
            actions={{
              get: handleFetchExperiences,
              edit: handleEditExperience,
              duplicate: handleDuplicateExperience,
            }}
          />
        );
      case "Event Series":
        return <EventSeriesList />;
      default: //secret edit experience tab
        return <BusinessExperienceForm experience={editingExp} isNew={false} />;
    }
  };

  return (
    <Dashboard>
      <div style={{ marginTop: 24 }}>
        <AdminPageTabList tabs={tabs} onSelect={setActiveTab} activeTab={activeTab} />
      </div>
      <div style={{ marginTop: 30 }}>{renderActiveTabContent()}</div>
    </Dashboard>
  );
};
